module.exports = __webpack_public_path__ + "img/10_2.d0ff42bc.png";